'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n'], ['\n  width: 100%;\n  height: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  min-height: 650px;\n  opacity: 0.5;\n  background-color: ', ';\n  right: 0;\n  left: 0;\n  position: fixed;\n  top: 0 !important;\n'], ['\n  width: 100%;\n  height: 100%;\n  min-height: 650px;\n  opacity: 0.5;\n  background-color: ', ';\n  right: 0;\n  left: 0;\n  position: fixed;\n  top: 0 !important;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n  background-color: ', ';\n  right: 0;\n  left: 0;\n  top: 0 !important;\n'], ['\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n  background-color: ', ';\n  right: 0;\n  left: 0;\n  top: 0 !important;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: 40px;\n  height: 40px;\n  top: 30%;\n  position: relative;\n  margin: 100px auto;\n  .double-bounce1, .double-bounce2 {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    background-color: #715AFF;\n    opacity: 0.7;\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    -webkit-animation: sk-bounce 3.0s infinite ease-in-out;\n    animation: sk-bounce 3.0s infinite ease-in-out;\n  }\n\n  .double-bounce2 {\n    -webkit-animation-delay: -1.0s;\n    animation-delay: -1.0s;\n  }\n\n  @-webkit-keyframes sk-bounce {\n    0%, 100% { -webkit-transform: scale(0.0) }\n    50% { -webkit-transform: scale(1.0) }\n  }\n\n  @keyframes sk-bounce {\n    0%, 100% {\n      transform: scale(0.0);\n      -webkit-transform: scale(0.0);\n    } 50% {\n      transform: scale(2.0);\n      -webkit-transform: scale(2.0);\n    }\n  }\n'], ['\n  width: 40px;\n  height: 40px;\n  top: 30%;\n  position: relative;\n  margin: 100px auto;\n  .double-bounce1, .double-bounce2 {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    background-color: #715AFF;\n    opacity: 0.7;\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    -webkit-animation: sk-bounce 3.0s infinite ease-in-out;\n    animation: sk-bounce 3.0s infinite ease-in-out;\n  }\n\n  .double-bounce2 {\n    -webkit-animation-delay: -1.0s;\n    animation-delay: -1.0s;\n  }\n\n  @-webkit-keyframes sk-bounce {\n    0%, 100% { -webkit-transform: scale(0.0) }\n    50% { -webkit-transform: scale(1.0) }\n  }\n\n  @keyframes sk-bounce {\n    0%, 100% {\n      transform: scale(0.0);\n      -webkit-transform: scale(0.0);\n    } 50% {\n      transform: scale(2.0);\n      -webkit-transform: scale(2.0);\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Spinner = _styledComponents2.default.div(_templateObject);

var SpinnerContainer = _styledComponents2.default.div(_templateObject2, _color2.default.white);

var SpinnerContainerInline = _styledComponents2.default.div(_templateObject3, _color2.default.white);

var SpinnerCircle = _styledComponents2.default.div(_templateObject4);

var MozartLoading = function MozartLoading(props) {
  var loading = props.loading,
      inline = props.inline,
      inlinefull = props.inlinefull,
      style = props.style,
      hideafter = props.hideafter,
      themeId = props.themeId;

  var id = props.id ? props.id : Math.random();

  if (hideafter) {
    setTimeout(function () {
      if (document.getElementById('spinner_' + id) !== null) {
        document.getElementById('spinner_' + id).style.display = 'none';
      }
    }, hideafter);
  }

  return _react2.default.createElement(
    Spinner,
    { id: 'spinner_' + id, 'data-qa': props.testId, 'data-theme': themeId },
    loading && !inline && !inlinefull && _react2.default.createElement(
      SpinnerContainer,
      { style: style },
      _react2.default.createElement(
        SpinnerCircle,
        null,
        _react2.default.createElement('div', { className: 'double-bounce1' }),
        _react2.default.createElement('div', { className: 'double-bounce2' })
      )
    ),
    loading && inline && _react2.default.createElement(
      SpinnerCircle,
      { style: style },
      _react2.default.createElement('div', { className: 'double-bounce1' }),
      _react2.default.createElement('div', { className: 'double-bounce2' })
    ),
    loading && inlinefull && _react2.default.createElement(
      SpinnerContainerInline,
      { style: style },
      _react2.default.createElement(
        SpinnerCircle,
        null,
        _react2.default.createElement('div', { className: 'double-bounce1' }),
        _react2.default.createElement('div', { className: 'double-bounce2' })
      )
    )
  );
};

MozartLoading.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** style override */
  style: _propTypes2.default.object,
  /** if don't want to use {this.state.loading && <MozartLoading />} */
  loading: _propTypes2.default.bool,
  /** if inline spinner will relative to the parent container without overlay background */
  inline: _propTypes2.default.bool,
  /** if inline spinner will relative to the parent container with overlay background */
  inlinefull: _propTypes2.default.bool,
  /** hide after certain millisecond */
  hideafter: _propTypes2.default.number
};

MozartLoading.defaultProps = {
  loading: true,
  testId: 'MozartLoading',
  themeId: 'MozartLoading',
  inline: false,
  inlinefull: false,
  style: { zIndex: 999999 }
};

exports.default = MozartLoading;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartLoading/MozartLoading.js
// module id = 715
// module chunks = 1